import { getDefaultConfig, lightTheme, Theme } from "@rainbow-me/rainbowkit";
import { Nunito } from "next/font/google";

import color from "@styles/settings/exported-colors.module.scss";
import merge from "lodash.merge";
import { blessnetMainnet, blessnetSepolia } from "@/config/bless-chain";
import {
  arbitrum,
  arbitrumSepolia,
  base,
  baseSepolia,
  mainnet,
  optimism,
  optimismSepolia,
  sepolia,
} from "wagmi/chains";
import { http } from "viem";

const nunito = Nunito({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700"],
});

export const config = getDefaultConfig({
  appName: "BlessNet",
  projectId: "96489a4b77fb52c8958c636e7b84936f",
  chains: [blessnetSepolia, blessnetMainnet, arbitrumSepolia],
  ssr: true,
});

export const dispenserConfigTestnet = getDefaultConfig({
  appName: "BlessNet",
  projectId: "96489a4b77fb52c8958c636e7b84936f",
  chains: [optimismSepolia, arbitrumSepolia, baseSepolia, sepolia],
  ssr: true,
});

export const dispenserConfigMainnet = getDefaultConfig({
  appName: "BlessNet",
  projectId: "96489a4b77fb52c8958c636e7b84936f",
  chains: [optimism, arbitrum, base, mainnet],
  transports: {
    [mainnet.id]: http(
      `https://eth-mainnet.g.alchemy.com/v2/${process.env.NEXT_PUBLIC_ALCHEMY_API_KEY}`,
    ),
  },
  ssr: true,
});

export const rainbowCustomTheme = merge(lightTheme(), {
  blurs: {
    modalOverlay: "small",
  },
  colors: {
    accentColor: color.lavender,
    accentColorForeground: color.white,
  },
  radii: {
    modal: "10px",
  },
  fonts: {
    body: nunito.style.fontFamily,
  },
} as Theme);
